import { post } from './client';

export const esqueciSenha = (email) => post('/auth/esqueci-senha', { email });
export const redefinirSenha = (token, novaSenha) =>
  post('/auth/redefinir-senha', { token, nova_senha: novaSenha });
